import scApi from "api/skedCore";
import { SKED_CORE_GET_ACCOUNTS_ROUTINE } from "constants/ActionTypes";
import { call, put, takeEvery } from "redux-saga/effects";
import { normalizeAccounts } from "utils/accounts";

const coreApi = new scApi();

export function* getAccounts(action) {
  yield put({ type: SKED_CORE_GET_ACCOUNTS_ROUTINE.REQUEST });
  try {
    const accountsResp = yield call(coreApi.getAccounts);
    const normalizedAccounts = normalizeAccounts(accountsResp.data);
    yield put({
      type: SKED_CORE_GET_ACCOUNTS_ROUTINE.SUCCESS,
      payload: { accounts: normalizedAccounts },
    });

    if (action?.payload?.callback) {
      yield call(action?.payload?.callback);
    }
  } catch (error) {
    yield put({
      type: SKED_CORE_GET_ACCOUNTS_ROUTINE.FAILURE,
      error: true,
      payload: error,
    });

    if (action?.payload?.callback) {
      yield call(action?.payload?.callback, error);
    }
  }
}

/// WATCHERS
///
export function* watchGetAccounts() {
  yield takeEvery(SKED_CORE_GET_ACCOUNTS_ROUTINE.TRIGGER, getAccounts);
}
